// Entry point for webpack bundling
// In the split architecture, jQuery and legacy scripts are loaded separately
// This file is for modern JavaScript code and CSS processing only

// Import CSS files that need webpack processing
// jQuery UI CSS
import './jquery-ui-1.12.1.custom/jquery-ui.structure.min.css';
import './jquery-ui-1.12.1.custom/jquery-ui.theme.min.css';

// jqGrid CSS
import './jqGrid-3.8/css/ui.jqgrid.css';

// Colorpicker CSS
import './colorpicker/css/colorpicker.css';

// Application CSS
import '../css/jquery-timepicker.css';
import '../css/jquery-ui-timepicker-addon-1.0.4.css';
import '../css/layout-default.css';
import '../css/pyramid-accordion.css';
import '../css/pyramid-layout.css';
import '../css/pyramid.css';

// Modern initialization code that runs after all scripts are loaded
// Since jQuery is loaded globally, we can use it here
if (typeof window !== 'undefined') {
  // Wait for DOM and jQuery to be ready
  document.addEventListener('DOMContentLoaded', function() {
    // Check if jQuery is available
    if (window.jQuery || window.$) {
      console.log('Webpack bundle loaded successfully. jQuery version:', $.fn.jquery);
      
      // Add any modern JavaScript initialization here
      // This runs AFTER all legacy scripts have been loaded
      
      // Example: You can add modern event handlers or initialize new features
      // $(document).ready(function() {
      //   console.log('Modern code initialized');
      // });
    } else {
      console.error('jQuery not found. Make sure legacy scripts are loaded before webpack bundle.');
    }
  });
}

// Export a module if needed for other modern code
export default {
  version: '1.0.0',
  init: function() {
    console.log('Modern LiveDC module initialized');
  }
};